import React from 'react'
import { InputField } from 'components/molecules'
import { TitlePage } from 'components/atoms'
import {  FormGroup, FormText } from 'reactstrap'
// import NotificationTemplatePreviewButton from './notification-template-preview-button'


const TinkerlustTemplateForm = () => (
  <>
    <TitlePage mainTitle={ 'Tinkerlust' } />
    <FormGroup>
      <FormText>
        { 'Notifikasi juga akan diterima melalui akun user (cek tanda lonceng): ' }
        <strong>
          <a
            href={ 'https://www.tinkerlust.com/account/notifications' }
            target='_blank'
            rel='noopener noreferrer'
          >
            { 'Halaman Notifikasi tanda lonceng akun user link' }
          </a>
        </strong>
      </FormText>
    </FormGroup>
    <InputField
      type='text'
      name='tinkerlust.title'
      label='Title'
      required={ true }
      formText={ <>
        {'Title Notifikasi tanda lonceng di akun user' }
      </> }
    />
    <InputField
      type='textarea'
      name='tinkerlust.body'
      rows='5'
      label='Body'
      required={ true }
      formText={ <>
        {'Text Notifikasi tanda lonceng di akun user' }
      </> }
    />

    <InputField
      type='text'
      name='tinkerlust.direct_url'
      label='Target Halaman'
    />
  </>

)

export default TinkerlustTemplateForm
